var CheckoutOption = /*#__PURE__*/function (CheckoutOption) {
  CheckoutOption["APPLE_PAY"] = "Apple Pay";
  CheckoutOption["CREDIT_CARD"] = "Credit Card";
  CheckoutOption["GOOGLE_PAY"] = "Google Pay";
  return CheckoutOption;
}(CheckoutOption || {});
export const DGC_AFFILIATION = 'Westfield - Digital Gift Card - AU';
export const isDGCEvent = event => {
  var _ecommerce;
  return !!(((_ecommerce = event.ecommerce) === null || _ecommerce === void 0 ? void 0 : _ecommerce.affiliation) === DGC_AFFILIATION);
};

// Soon we should be able to delete the non-interface
// versions of these types soon